import {TrailerFormDefaultValues, TrailerFormProps, TrailerFormRawValues, TrailerFormType} from "./TrailerForm";
import {useTranslation} from "react-i18next";
import {useForm} from "@mantine/form";
import {getObjectId, isStringUndefinedOrBlank} from "@ots-frontend/ots-data";
import {useApp} from "../../../providers/RegionProvider/RegionProvider";
import { useAuth } from "../../../providers/AuthProvider/AuthProvider";

const getInitialValues = (defaultValues: TrailerFormDefaultValues | undefined): TrailerFormRawValues => {
  return {
    name: defaultValues?.name,
    barcode: defaultValues?.barcode,
    company: getObjectId(defaultValues?.company),
    freightType: getObjectId(defaultValues?.freightType),
    size: defaultValues?.size?.size,
    maxSize: defaultValues?.size?.maxSize,
    sizeUom: defaultValues?.size?.units,
    weight: defaultValues?.weight?.number,
    weightUom: defaultValues?.weight?.units,
    doNotUse: defaultValues?.doNotUse,
  }
}

export type UseTrailerFormProps = Pick<TrailerFormProps, 'defaultValues'> & {}

export function useTrailerForm(props: UseTrailerFormProps): TrailerFormType {
  const {
    defaultValues
  } = props

  const {t} = useTranslation(["common"])

  const {uoms} = useApp()
  const { companyId } = useAuth()

  const form = useForm({
    initialValues: getInitialValues({
      ...defaultValues,
      company: defaultValues?.company ?? companyId,
      size: {
        size: defaultValues?.size?.size,
        maxSize: defaultValues?.size?.maxSize,
        units: defaultValues?.size?.units ?? uoms?.volume,
      },
      weight: {
        number: defaultValues?.weight?.number ?? 0,
        units: defaultValues?.weight?.units ?? uoms?.weight,
      },
    }),
    validate: {
      name: (value) => value ? undefined : t("common.validation.required", "Required"),
      size: (value) => value ? undefined : t("common.validation.required", "Required"),
      maxSize: (value) => value ? undefined : t("common.validation.required", "Required"),
      sizeUom: (value) => value ? undefined : t("common.validation.required", "Required"),
      company: (value) => value ? undefined : t("common.validation.required", "Required"),
      freightType: (value) => value ? undefined : t("common.validation.required", "Required"),
      weightUom: (value, values) => isStringUndefinedOrBlank(value) && (values.weight) ? t("common.validation.required", "Required") : undefined,
    },
  })

  return form
}
